import React from 'react';
import { Container } from '@mui/material';
import { MessageProps } from './types';
import './MessageContainer.scss';

const MessageContainer: React.FC<MessageProps> = (props) => {
    const coachesId = props.coaches.map((x) => x.uid);
    const isCoachMessage = coachesId.includes(props.message.idFrom);

    const messageDate = () => {
        const sendDate = new Date(props.message?.timestamp);
        if (
            sendDate.getFullYear() === new Date().getFullYear() &&
            sendDate.getMonth() === new Date().getMonth() &&
            sendDate.getDate() === new Date().getDate()
        ) {
            return sendDate.toLocaleTimeString('pl', { hour: '2-digit', minute: '2-digit' });
        } else {
            return sendDate.toLocaleTimeString('pl', {
                day: '2-digit',
                month: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        }
    };
    return (
        <div className={`message ${isCoachMessage ? 'current-user' : 'interlocutor'}`}>
            {isCoachMessage ? (
                <p className="message-date current-user">{messageDate()}</p>
            ) : (
                <p className="message-date">{`${props.interlocutor.userName}  ${messageDate()}`}</p>
            )}
            <Container className="message-container message-color">
                <p className="message-text">{props.message.message}</p>
            </Container>
        </div>
    );
};

export default MessageContainer;
